module.exports = __webpack_public_path__ + "static/fib-shot-3-8d5b61d8f62ff904394ca1546e321df1.jpg";